import { Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { NavigationEnd, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import 'rxjs/add/operator/filter';
import { Subscription } from 'rxjs/Subscription';
import { NotesService } from '../../services/shared/notes.service';
import { TechService } from '../../services/tech.service';
const SMALL_WIDTH_BREAKPOINT = 960;

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html'
})

export class AdminLayoutComponent implements OnInit, OnDestroy {

  @ViewChild('sidemenu') sidemenu;
  @ViewChild(PerfectScrollbarDirective) directiveScroll: PerfectScrollbarDirective;
  @ViewChild('notifications') notifications: MatSidenav;
  SalesData: any;
  reportIssueToggle = false;
  notificationsToggle = false;
  suggestToggle = false;
  askQuestionToggle = false;
  private _router: Subscription;
  mediaMatcher: MediaQueryList = matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`);
  url: string;
  sidePanelOpened;
  options = {
    collapsed: false,
    compact: false,
    boxed: false,
    dark: false,
    dir: 'ltr'
  };
  editValue: any;
  public config: PerfectScrollbarConfigInterface = {};
  getSideNavSubscription: Subscription;
  closeSideNavSubscription: Subscription;

  constructor(
    private router: Router, zone: NgZone,
    private notesService: NotesService,
    private techService: TechService) {
    this.mediaMatcher.addListener(mql => zone.run(() => {
      this.mediaMatcher = mql;
    }));
  }

  ngOnInit() {
    this.getSideNavSubscription = this.techService.sideNav.subscribe(data => {
      if (data !== null) {
        if (data['title'] === 'ask') {
          this.editValue = data;
          this.askQuestion(this.notifications);
        } else if (data['title'] === 'report') {
          this.editValue = data;
          this.reportIssue(this.notifications);
        } else if (data['title'] === 'suggest') {
          this.editValue = data;
          this.suggestEnhancement(this.notifications);
        }
      }
    });
    this.closeSideNavSubscription = this.techService.closeSideNav.subscribe(value => {
      if (value === 'close') {
        this.close(this.notifications);
      }
    });

    this.url = this.router.url;
    this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
      document.querySelector('.app-inner > .mat-drawer-content > div').scrollTop = 0;
      this.url = event.url;
      this.runOnRouteChange();
    });
  }

  unsubscribe(subscription: any) {
    if (subscription !== null && subscription !== undefined) {
      subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.unsubscribe(this._router);
    this.unsubscribe(this.closeSideNavSubscription);
    this.unsubscribe(this.getSideNavSubscription);
    this.SalesData = null;
    this.notificationsToggle = null;
    this.suggestToggle = null;
    this.askQuestionToggle = null;
    this.reportIssueToggle = null;
    this.router = null;
    this.notesService = null;
    this.mediaMatcher = null;
    this.url = null;
    this.sidePanelOpened = null;
    this.options = null;
    this.sidemenu = null;
    this.directiveScroll = null;
    this.config = null;
    this.editValue = null;
    this.techService = null;
  }

  runOnRouteChange(): void {
    if (this.isOver()) {
      this.sidemenu.close();
    }
    this.updatePS();
  }

  close(j) {
    if (this.notificationsToggle) {
      this.notificationsToggle = false;
      j.toggle();
    }
    if (this.reportIssueToggle) {
      this.editValue = null;
      this.reportIssueToggle = false;
      j.toggle();
    }
    if (this.suggestToggle) {
      this.editValue = null;
      this.suggestToggle = false;
      j.toggle();
    }
    if (this.askQuestionToggle) {
      this.editValue = null;
      this.askQuestionToggle = false;
      j.toggle();
    }
    this.notesService.refreshAlertCount('update');
  }

  notify(j) {
    if (this.reportIssueToggle || this.suggestToggle || this.askQuestionToggle) {
      j.toggle();
    }
    if (!this.notificationsToggle) {
      this.notificationsToggle = true;
      this.reportIssueToggle = false;
      this.suggestToggle = false;
      this.askQuestionToggle = false;
      j.toggle();
    } else {
      this.notificationsToggle = false;
      j.toggle();
    }
  }

  reportIssueTriggerer(event) {
    this.editValue = null;
    this.reportIssue(event);
  }

  reportIssue(event) {
    if (this.notificationsToggle || this.suggestToggle || this.askQuestionToggle) {
      event.toggle();
    }
    if (!this.reportIssueToggle) {
      this.reportIssueToggle = true;
      this.notificationsToggle = false;
      this.suggestToggle = false;
      this.askQuestionToggle = false;
      event.toggle();
    } else {
      this.reportIssueToggle = false;
      event.toggle();
    }
  }

  suggestEnhancementTriggerer(event) {
    this.editValue = null;
    this.suggestEnhancement(event);
  }

  suggestEnhancement(event) {
    if (this.notificationsToggle || this.reportIssueToggle || this.askQuestionToggle) {
      event.toggle();
    }
    if (!this.suggestToggle) {
      this.suggestToggle = true;
      this.notificationsToggle = false;
      this.reportIssueToggle = false;
      this.askQuestionToggle = false;
      event.toggle();
    } else {
      this.suggestToggle = false;
      event.toggle();
    }
  }

  askQuestionTriggerer(event) {
    this.editValue = null;
    this.askQuestion(event);
  }

  askQuestion(event) {
    if (this.notificationsToggle || this.reportIssueToggle || this.suggestToggle) {
      event.toggle();
    }
    if (!this.askQuestionToggle) {
      this.askQuestionToggle = true;
      this.notificationsToggle = false;
      this.reportIssueToggle = false;
      this.suggestToggle = false;
      event.toggle();
    } else {
      this.askQuestionToggle = false;
      event.toggle();
    }
  }

  receiveOptions($event): void {
    this.options = $event;
  }

  isOver(): boolean {
    if (this.url === '/apps/messages' ||
      this.url === '/apps/calendar' ||
      this.url === '/apps/media' ||
      this.url === '/maps/leaflet' ||
      this.url === '/taskboard') {
      return true;
    } else {
      return this.mediaMatcher.matches;
    }
  }

  menuMouseOver(): void {
    if (this.mediaMatcher.matches && this.options.collapsed) {
      this.sidemenu.mode = 'over';
    }
  }

  menuMouseOut(): void {
    if (this.mediaMatcher.matches && this.options.collapsed) {
      this.sidemenu.mode = 'side';
    }
  }

  updatePS(): void {
    if (!this.mediaMatcher.matches && !this.options.compact) {
      setTimeout(() => {
        this.directiveScroll.update();
      }, 350);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/admin-layout/admin-layout.component.ts